import { useContext, useEffect, useState, useRef } from 'react';
import ContextStates from '../context/ContextStates';
import axios from 'axios';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import { Url } from './Url';
import Select from 'react-select';
import jsPDF from 'jspdf'


// Normaliza cualquier valor numérico (quita $ puntos de miles y maneja vacíos)
const num = (v) => {
    if (v === null || v === undefined) return 0;
    const s = String(v).trim()
        .replace(/\s+/g, '')
        .replace(/\$/g, '')
        .replace(/\./g, '')        // quita separador de miles estilo es-AR
        .replace(/,/g, '.');       // coma → punto para decimales
    const n = Number.parseFloat(s);
    return Number.isFinite(n) ? n : 0;
};

// Precio unitario efectivo según modo y promo
const unitPrice = (item, esMayorista) => {
    if (esMayorista) return num(item.preciopormayor);

    // Promos 1 y 2: precio promocional por unidad
    if (item.tipopromo === '1' || item.tipopromo === '2') {
        return num(item.preciopromocion);
    }

    // Promo 3: paga X lleva Y  → calcular unitario efectivo
    if (item.tipopromo === '3') {
        const cantidad = num(item.cantidad);
        const cantidadMin = num(item.cantidadminima);
        const cantDesc = num(item.cantidaddescuento);
        const p = num(item.precio);

        if (cantidad >= cantidadMin && cantidadMin > 0) {
            const promos = Math.floor(cantidad / cantidadMin);
            const cantPagos = cantidad - (cantDesc * promos);
            const totalPromo = cantPagos * p;
            return cantidad > 0 ? totalPromo / cantidad : p;
        }
        return p;
    }

    // Sin promo
    return num(item.precio);
};

// Subtotal (cantidad * unitPrice efectivo)
const lineTotal = (item, esMayorista) => {
    const up = unitPrice(item, esMayorista);
    return up * num(item.cantidad);
};

// Formateador ARS seguro
const ars = (n) => num(n).toLocaleString('es-AR', { maximumFractionDigits: 2 });

const FinalizarVenta = () => {
    const [total, setTotal] = useState(0)
    const [fecha, setFecha] = useState('')
    const [hora, setHora] = useState('')
    const [nombre, setNombre] = useState('')
    const [numero, setNumero] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    const [cuit, setCuit] = useState('')
    const [fechaInicio, setFechaInicio] = useState('')
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const [medio1, setMedio1] = useState('1')
    const [medio2, setMedio2] = useState('3')
    const [importe1, setImporte1] = useState('')
    const [importe2, setImporte2] = useState('')
    const [efectivo, setEfectivo] = useState('')
    const [envio, setEnvio] = useState(false)
    const [finalizar, setFinalizar] = useState(true)
    const [procesando, setProcesando] = useState(false)
    const [datosFactura, setDatosFactura] = useState('')
    const [finVenta, setFinVenta] = useState(false)
    const [auxVenta, setAuxVenta] = useState([])

    const [prestamo, setPrestamo] = useState(false)
    const [descuentos, setDescuentos] = useState([])

    const { venta, ventaSelected, precio, cliente, setCliente, presupuesto, setVenta, setFormView, setViewOpen, modify, setModify, idUsuario, clientes, setClientes, setFormPrev, puntoVenta, porcentajeDesc, setPorcentajeDesc, descAux, totalDesc, editarList, setTotalDesc, auxTotal, setAuxTotal } = useContext(ContextStates);
    const componentRef = useRef();

    useEffect(() => {
        if (medioPago === '7') {
            console.log("verifica", importe2)
            if (importe1 === '') {
                setFinalizar(false)
            }
            else {
                let aux = 0;
                if (importe1 > total) {
                    setFinalizar(false)
                    setImporte2('')
                }
                else {
                    if (medio1 === '3') {
                        aux = total - importe1 + (importe1 * 0.2);
                    } else {
                        aux = total - importe1;
                        if (medio2 === '3') {
                            aux = aux * 1.2;
                        }
                    }
                    setImporte2(aux)
                    setFinalizar(true)
                }
            }
        }
    }, [medioPago, importe1, medio1, medio2])

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            let rData = [...descuentos]
            venta.forEach(element => {
                if (!precio) {
                    if (element.tipopromo === '1' || element.tipopromo === '2') {
                        aux = aux + parseFloat(element.preciopromocion * element.cantidad);
                        let montoDesc = parseFloat(element.precio * element.cantidad) - parseFloat(element.preciopromocion * element.cantidad);
                        let descuento = {
                            id: element.id,
                            descripcion: element.descripcion,
                            monto: montoDesc
                        }
                        rData.push(descuento)
                    }
                    else {
                        if (element.tipopromo === '3') {
                            let precio = 0;
                            if (element.cantidad >= element.cantidadminima) {
                                let cantPromos = parseFloat(element.cantidad) / parseFloat(element.cantidadminima);
                                let cantPagos = element.cantidad - (parseFloat(element.cantidaddescuento) * cantPromos);
                                precio = cantPagos * parseFloat(element.precio);
                                let montoDesc = parseFloat(element.precio * element.cantidad) - precio;
                                let descuento = {
                                    id: element.id,
                                    descripcion: element.descripcion,
                                    monto: montoDesc
                                }
                                rData.push(descuento)
                            } else {
                                precio = parseFloat(element.cantidad) * parseFloat(element.precio);
                            }
                            aux = aux + precio;
                        } else {
                            aux = aux + parseFloat(element.precio * element.cantidad);
                        }
                    }
                }
                else {
                    aux = aux + parseFloat(element.preciopormayor * element.cantidad);
                }
            });
            setDescuentos(rData)
            setTotal(aux)
        }
        calcTotal()
    }, [venta])

    useEffect(() => {
        if ((total > 0) && descAux !== '') {

            let aux = total - (total * parseFloat(descAux) / 100)
            setTotalDesc(aux)
        }

    }, [total, descAux])

    useEffect(() => {
        if ((auxTotal > 0) && descAux !== '') {

            let aux = auxTotal - (auxTotal * parseFloat(descAux) / 100)
            setTotalDesc(aux)
        }

    }, [auxTotal, descAux])

    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])

    useEffect(() => {
        const consultaClientes = async () => {
            const formData = new FormData()
            //formData.append('idusuario', idUsuario)
            formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/listClientes.php',
                    method: 'POST',
                    data: formData,
                })
                setClientes(response.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        consultaClientes()
    }, [modify])

    const facturaAfip = async () => {
        if (total > 0 && medioPago === '5') {
            setProcesando(true)
            const formData = new FormData()
            formData.append('total', total);
            try {
                const response = await axios({
                    url: Url + 'api/factura.php',
                    method: 'POST',
                    data: formData,
                })
                setProcesando(false)
                setDatosFactura(response.data.results.cae)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const finalizarVenta = async () => {
        if (finalizar) {
            let urldir = 'api/finVenta.php'
            if (editarList)
                urldir = 'api/setVenta.php'
            setFinalizar(false)
            let tipoPrecio = 0;
            if (precio) {
                tipoPrecio = 1;
            }
            let genPresupuesto = 0;
            if (presupuesto)
                genPresupuesto = 1;
            const auxVenta = JSON.stringify(venta)
            const auxDescuentos = JSON.stringify(descuentos)
            let env = 0;
            if (envio) {
                env = 1;
            }
            const formData = new FormData()
            formData.append('id', ventaSelected.id);
            formData.append('venta', auxVenta);
            formData.append('mediopago', medioPago);
            formData.append('idusuario', idUsuario);
            formData.append('cliente', cliente.id);
            formData.append('total', total);
            formData.append('puntoventa', puntoVenta);
            formData.append('tipoprecio', tipoPrecio);
            formData.append('presupuesto', genPresupuesto);
            formData.append('descuentos', auxDescuentos);
            formData.append('porcentajedesc', porcentajeDesc);
            formData.append('medio1', medio1);
            formData.append('medio2', medio2);
            formData.append('importe1', importe1);
            formData.append('envio', env);
            try {
                const response = await axios({
                    url: Url + urldir,
                    'Content-Type': 'application/json',
                    method: 'POST',
                    data: formData,
                    dataType: 'JSON',
                })
                console.log(response)
                setFecha(response.data.results.fecha);
                setHora(response.data.results.hora);
                setNombre(response.data.results.nombre)
                setNumero(response.data.results.numero)
                setRazonSocial(response.data.results.razonsocial)
                setCuit(response.data.results.cuit)
                setFechaInicio(response.data.results.fechainicio)
                setPorcentajeDesc('')
                setAuxVenta([...venta]); // Hacer una copia del array actual
                setAuxTotal(total) // Guardar el total actual

                // LUEGO limpia los estados
                setVenta([]);
                setFinVenta(true)

                let aux = modify + 1;
                setModify(aux)
                setDatosFactura('')

            } catch (e) {
                console.log(e)
            }
        }
    }

    const handleSelect = (item) => {
        setCliente(item)
        //console.log(item)
    }

    const handleAdd = () => {
        setFormPrev(2)
        setFormView(30)
    }

    const calcPrecio = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio.toLocaleString("es-AR", { maximumFractionDigits: 2 }));
    }


    const calcTotal = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio.toLocaleString("es-AR", { maximumFractionDigits: 2 }));
    }


    return (
        <div className="w-full mx-auto">
            {!finVenta ? (
                <div className='w-10/12 mx-auto'>
                    <div className='w-full mx-auto'>
                        <p className='text-center bg-orange-200 p-4 rounded-lg text-5xl font-light'>
                            {presupuesto ? 'Total Presupuesto ' : 'Ésta venta'} $ {(descAux !== '' && descAux !== 0) ? parseFloat(totalDesc).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                    </div>
                    {!presupuesto && (
                        <>
                            <div className='w-full mt-2 mb-2 bg-gray-50 rounded-lg p-5'>
                                <input type='checkbox' name='checkTipo' id='checkTipo' checked={envio} onChange={() => setEnvio(!envio)} /><label htmlFor='checkTipo' className='ml-5 text-lg text-gray-800'>Envío</label>
                            </div>
                            <div className='w-full sm:flex'>
                                <div className='bg-gray-50 rounded-lg p-5 w-full'>
                                    {typeof medios !== 'undefined' && medios.map((item, index) =>
                                        <div key={index} className="radio">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="medioPago"
                                                    value={item.id}
                                                    checked={medioPago === item.id}
                                                    onChange={() => setMedioPago(item.id)}
                                                    className='mr-5'
                                                />
                                                {item.descripcion}
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div>
                                {medioPago === '1' && (
                                    <div className='w-full mt-5 mb-10 bg-blue-200 rounded-lg p-5'>
                                        <div className="sm:items-start">
                                            <label className="block text-gray-800 text-2xl uppercase font-bold" htmlFor='efectivo'>Efectivo</label>
                                            <input
                                                type='number'
                                                className='p-2 rounded border border-gray-400 w-full'
                                                value={efectivo}
                                                id="efectivo"
                                                onChange={(e) => setEfectivo(e.target.value)}
                                                autoFocus
                                            />
                                        </div>
                                        <p className='text-4xl text-center font-bold mt-5'>Cambio: ${efectivo >= total && parseFloat(efectivo - total).toFixed(2)}</p>
                                    </div>
                                )}
                                {medioPago === '5' ? (
                                    <div className='w-full mt-5 mb-10 bg-gray-50 rounded-lg p-5'>
                                        <div className="sm:items-start">
                                            {datosFactura !== '' ? (
                                                <>
                                                    <p className='bg-green-300 text-green-800 border border-green-800 rounded-xl p-4 w-full'>Se ha generado la factura con CAE {datosFactura}</p>
                                                </>
                                            ) : (
                                                !procesando ? (
                                                    <button type='button'
                                                        className='w-full p-3 bg-blue-500 text-white uppercase font-semibold rounded'
                                                        onClick={() => facturaAfip()}
                                                    >
                                                        Generar Factura Electrónica
                                                    </button>

                                                ) : (
                                                    <p className='bg-gray-300 text-gray-800 border border-gray-800 rounded-xl p-4 w-full'>Aguarde mientras se genera la factura, por favor</p>
                                                )

                                            )}
                                        </div>
                                        <p className='text-xl font-bold mt-5'>Cambio: ${efectivo > total && parseFloat(efectivo - total)}</p>
                                    </div>
                                ) : medioPago === '6' ? (
                                    <div className='w-full mt-5 mb-10 bg-gray-50 rounded-lg p-5'>
                                        <div className="sm:items-start">
                                            <Select
                                                options={clientes}
                                                placeholder="Seleccione Cliente"
                                                onChange={(value) => handleSelect(value)}
                                                name='sCliente'
                                            />
                                            <button type='button'
                                                className='p-3 bg-orange-500 text-white uppercase font-semibold rounded'
                                                onClick={() => handleAdd()}
                                            >
                                                Agregar Cliente
                                            </button>
                                        </div>
                                    </div>
                                ) : medioPago === '7' && (
                                    <>
                                        <div className='w-full mt-5 bg-blue-50 rounded-lg p-5'>
                                            <p className='text-xl font-bold'>Medio de Pago 1</p>
                                            <div className='rounded-lg p-5 sm:w-1/2'>
                                                {typeof medios !== 'undefined' && medios.map((item, index) =>
                                                    item.id !== '7' &&
                                                    <div key={index} className="radio">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                name="medioPago1"
                                                                value={item.id}
                                                                checked={medio1 === item.id}
                                                                onChange={() => setMedio1(item.id)}
                                                                className='mr-5'
                                                            />
                                                            {item.descripcion} {item.id === '3' && '(20% de recargo con éste medio)'}
                                                        </label>
                                                    </div>
                                                )}
                                                <label className="block text-gray-800" htmlFor='importe1'>Importe Medio de Pago 1</label>
                                                <input
                                                    type='text'
                                                    className={`p-2 rounded border border-gray-400 w-full ${importe1 > total ? 'bg-red-300' : 'bg-white'}`}
                                                    value={importe1}
                                                    id="importe1"
                                                    onChange={(e) => setImporte1(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-full mt-5 mb-10 bg-blue-50 rounded-lg p-5'>
                                            <p className='text-xl font-bold'>Medio de Pago 2</p>
                                            <div className='mt-2 rounded-lg p-5 sm:w-1/2'>
                                                {typeof medios !== 'undefined' && medios.map((item, index) =>
                                                    item.id !== '7' && item.id !== medio1 &&
                                                    <div key={index} className="radio">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                name="medioPago2"
                                                                value={item.id}
                                                                checked={medio2 === item.id}
                                                                onChange={() => setMedio2(item.id)}
                                                                className='mr-5'
                                                            />
                                                            {item.descripcion} {item.id === '3' && '(20% de recargo con éste medio)'}
                                                        </label>
                                                    </div>
                                                )}
                                                <label className="block text-gray-800" htmlFor='importe2'>Importe Medio de Pago 2</label>
                                                <input
                                                    type='text'
                                                    className='p-2 rounded border border-gray-400 w-full'
                                                    value={importe2}
                                                    id="importe2"
                                                    onChange={(e) => setImporte2(e.target.value)}
                                                />

                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                    <div className='w-1/3 mx-auto mt-4'>
                        <button type='button'
                            className={`w-full p-3 text-white uppercase font-semibold rounded ${finalizar ? 'bg-green-500' : 'bg-green-200'}`}
                            onClick={() => finalizarVenta()}
                            disabled={!finalizar}
                        >
                            {presupuesto ? 'Finalizar Presupuesto' : 'Finalizar venta'}

                        </button>
                    </div>
                </div>

            ) : (
                <div className='w-10/12 mx-auto'>
                    <div className='print:px-4 print:text-xs print:h-svh print:mt-[3rem]' ref={componentRef}>
                        <div className='w-full mx-auto mt-15'>
                            <p className='text-center text-2xl mt-15 font-bold print:text-lg'>{nombre}</p>
                            <p className='text-center text-xl print:text-lg uppercase'>{`${presupuesto ? 'Presupuesto' : 'Recibo'}`} Nº {numero}</p>
                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>Cliente: {typeof cliente.cliente !== 'undefined' && cliente.cliente}</p>
                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>Dirección: {typeof cliente.domicilio !== 'undefined' && cliente.domicilio}</p>
                            <div className='w-full mt-3 mb-7'>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Fecha {fecha}</p>
                                </div>
                                {!presupuesto && (
                                    <div className='w-full print:pl-2'>
                                        <p className='text-left'>Hora {hora}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        <table className='w-full mx-auto'>
                            <thead>
                                <tr className='p-1 bg-blue-400 text-white text-center'>
                                    <th>Cod.</th>
                                    <th>Descripción</th>
                                    <th>Precio / U</th>
                                    <th>Cantidad</th>
                                    <th>Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    typeof auxVenta !== 'undefined' && auxVenta.map((item, index) => (
                                        item.cantidad > 0 && (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.codigo}</td>
                                                <td>{item.descripcion}</td>
                                                <td>
                                                    $ {ars(unitPrice(item, precio))}
                                                </td>
                                                <td>{item.cantidad}</td>
                                                <td>
                                                    $ {ars(lineTotal(item, precio))}
                                                </td>
                                            </tr>
                                        )
                                    ))
                                }
                            </tbody>
                        </table>
                        {(typeof descuentos !== 'undefined' && descuentos.length > 0) || porcentajeDesc !== '' && (
                            <div className='w-full'>
                                <p className='text-left font-bold uppercase text-3xl print:text-sm'>Descuentos</p>
                                <table className='w-full mx-auto'>
                                    <thead>
                                        <tr className='p-1 bg-blue-400 text-white text-center'>
                                            <th>Descripción</th>
                                            <th>Monto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            typeof descuentos !== 'undefined' && descuentos.map((item, index) => (
                                                <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                    <td>{item.label}</td>
                                                    <td>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                                </tr>
                                            ))
                                        }
                                        {porcentajeDesc !== '' && porcentajeDesc !== 0 && (
                                            <tr className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center`}>
                                                <td>Descuento del {porcentajeDesc}%</td>
                                                <td>-$ {(parseFloat(auxTotal) - parseFloat(totalDesc)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <div className='w-full flex'>
                            <div className='w-1/2 print:pl-2'>
                                <p className='text-left print:text-right font-bold uppercase text-3xl print:text-sm'>{descAux !== '' && descAux !== 0 ? 'Total sin descuento' : 'Total a pagar'}</p>
                            </div>
                            <div className='w-1/2 print:pr-4'>
                                <p className='text-right font-bold uppercase text-3xl print:text-sm'>$ {parseFloat(auxTotal).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                            </div>
                        </div>
                        {descAux !== '' && descAux !== 0 && (
                            <>
                                <div className='w-full flex'>
                                    <div className='w-1/2 print:pl-2'>
                                        <p className='text-left print:text-right font-bold uppercase text-3xl print:text-sm'>Descuento</p>
                                    </div>
                                    <div className='w-1/2 print:pr-4'>
                                        <p className='text-right font-bold uppercase text-3xl print:text-sm'>- $ {(parseFloat(auxTotal) - parseFloat(totalDesc)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                    </div>
                                </div>
                                <div className='w-full flex'>
                                    <div className='w-1/2 print:pl-2'>
                                        <p className='text-left print:text-right font-bold uppercase text-3xl print:text-sm'>Total a Pagar</p>
                                    </div>
                                    <div className='w-1/2 print:pr-4'>
                                        <p className='text-right font-bold uppercase text-3xl print:text-sm'>$ {parseFloat(totalDesc).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="w-full mt-5 rounded-lg px-3 flex justify-center">
                        <ReactToPrint
                            trigger={() =>
                                <button
                                    type="button"
                                    className="w-1/3 sm:w-1/4 flex shadow-md p-3 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                                >
                                    <FaPrint className='mx-auto mt-1' />
                                    <p className='mx-auto text-center'>
                                        Imprimir Comprobante
                                    </p>
                                </button>}
                            content={() => componentRef.current}
                        />
                        <button
                            type="button"
                            className="w-1/4 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                            onClick={() => setViewOpen(false)}
                        >
                            Salir
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FinalizarVenta